<template lang='pug'>
  include ./../../mixins
  div
    validation-observer(
      tag="form"
      ref="observer"
      v-slot="props"
      @submit.prevent="validateBeforeSubmit"
    )

      validation-provider.position_relative(
        tag="div"
        v-slot="{errors}"
        rules="required"
        name="password0"
      )
        +b.form--input.--placeholder_common.margin_bottom_lg.INPUT(
          :placeholder="_('Enter Old Password')"
          type='password'
          name='password0'
          @keyup.enter='validateBeforeSubmit'
          required
          v-model="formdata.password0"
        )

        +b.error-text--login.SPAN {{ errors[0] }}

      validation-provider.position_relative(
        tag="div"
        v-slot="{errors}"
        rules="required"
        name="password1"
      )
        +b.form--input.--placeholder_common.margin_bottom_lg.INPUT(
          :placeholder="_('Enter New Password')"
          type='password'
          @keyup.enter='validateBeforeSubmit'
          name='password1'
          required
          v-model="formdata.password1"
        )

        +b.error-text--login.SPAN {{ errors[0] }}
      validation-provider.position_relative(
        tag="div"
        v-slot="{errors}"
        rules="required"
        
        name="password2"
      )
        +b.form--input.--placeholder_common.margin_bottom_lg.INPUT(
          :placeholder="_('Repeat New Password')"
          type='password'
          name='password2'
          @keyup.enter='validateBeforeSubmit'
          required
          v-model="formdata.password2"
        )

        +b.error-text--login.SPAN {{ errors[0] }}
      +b.button--color_blue.--width_full.--submit.fs_2md.BUTTON(
        @click.prevent="validateBeforeSubmit"
        :disabled='isLoad'
        type='submit'
      ) {{_('Change Password')}}
      +b.position_relative.margin_top_lg(v-if='errorText.length > 0')
        +b.error-text--login.SPAN {{ errorText }}



</template>

<script>
import SuccessModal from './../Modals/SuccessModal'
import FormMixin, { defaultValidatorErrorsParser } from './../../mixins/form-mixin'
import { passwordResource } from '@services/auth'
export default {
  mixins: [ FormMixin ],
  data() {
    return {
      errorText: '',
      formdata: {
        password0: '',
        password1: '',
        password2: '',
      }
    }
  },


  methods: {
    showModal(location) {
      this.$modal.show(SuccessModal, {
        url: location
      }, 
      {
        name: 'SuccessModal',
        classes: "modal modal--container modal--padding_lg",
      })
    },

    send(data) {
      return passwordResource.execute({}, data)
        .then((res) => {       
          this.showModal(res.data.location)
          this.$emit('close-modal')
        })
    },

    async validateBeforeSubmit() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        this.submit(isValid)
        // this.send(this.formdata)
      } else {
        return
      }
    },

    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(parsed)
      this.errorText = parsed.non_field_errors[0]
      
    },
  }


}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/ChangePassword.vue